/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aitexteventdescription3Inputs */

const en_aitexteventdescription3 = /** @type {(inputs: Aitexteventdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Describe your event and let AI write the description.`)
};

const de_aitexteventdescription3 = /** @type {(inputs: Aitexteventdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beschreib dein Event und lass die KI den Text schreiben.`)
};

/**
* | output |
* | --- |
* | "Describe your event and let AI write the description." |
*
* @param {Aitexteventdescription3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aitexteventdescription3 = /** @type {((inputs?: Aitexteventdescription3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aitexteventdescription3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aitexteventdescription3(inputs)
	return de_aitexteventdescription3(inputs)
});
export { aitexteventdescription3 as "aiTextEventDescription" }